// An event's feedback from /live once it's over (LiveFeedback.vue; Seán, 2026-11-03): a Net
// Promoter Score (0–10) and any other comments, kept as Mastery keeps it, inside the event in
// the account's Clerk data: publicMetadata.events["masterclass-2026"].feedback =
// {netPromoterScore, comments}. Written through the fullstack (update/clerk.js checks it: only
// the server writes publicMetadata). Given once: the form then gives way to the end state.
import {authFetch} from "@/composables/useAuthFetch";

// "masterclass-2026" → "Masterclass 2026", "workshop-2026" → "VIZBI 2026" (/live's names)
export function getEventName(eventKey) {
  const [type, year] = String(eventKey).split("-");
  return type === "masterclass" ? `Masterclass ${year}` : `VIZBI ${year}`;
}

// "masterclass-2026" → "Masterclass"
export const getEventType = (eventKey) => (String(eventKey).startsWith("masterclass")
  ? "Masterclass" : "Workshop");

// the account's feedback status for an event, from the server (api/v1/user/feedback.get.js):
// {event, state, closesAt, events, upcoming}; eventKey "" for the default event
export async function fetchFeedbackStatus(eventKey = "") {
  const query = eventKey ? `?event=${encodeURIComponent(eventKey)}` : "";
  const response = await authFetch(`/api/v1/user/feedback${query}`);
  if (!response.ok) throw new Error(`status ${response.status}`);
  return await response.json();
}

// "Masterclass 2026" → "masterclass-2026", "VIZBI 2026" → "workshop-2026"
export function getFeedbackKey(eventName) {
  const year = String(eventName).match(/\d{4}/)?.[0] || "";
  const type = String(eventName).startsWith("Masterclass") ? "masterclass" : "workshop";
  return `${type}-${year}`;
}

export function getHasFeedback(user, eventName) {
  return Boolean(user?.publicMetadata?.events?.[getFeedbackKey(eventName)]?.feedback);
}

// merged into the account's events (its roles kept); then the account read again. eventKeys:
// one event, or both when one answer is for both (FEEDBACK.md § Both events at once)
export async function fetchSaveFeedback(user, eventKeys, {netPromoterScore, comments}) {
  const feedback = {netPromoterScore, comments};
  const events = Object.fromEntries(eventKeys.map((key) => [key, {feedback}]));
  const body = {publicMetadata: {events}};
  const response = await authFetch("/api/v1/user/update/clerk", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (data.ok !== true) throw new Error(data.message || "not saved");
  await user.reload();
}
